<template>
  <div class="loginWrap">
    <template v-if="isLoginStatus">
      <div class="loginInfo">
        <div class="itm">
          金龙元宝<Tip :titInd="0" style="width:20px;vertical-align: bottom"></Tip>：{{ loginInfo.wallteInfos[0].balance |
            formatZero }}
        </div>
        <div class="itm">
          银龙元宝<Tip :titInd="1" style="width:20px;vertical-align: bottom"></Tip>：{{ loginInfo.wallteInfos[1].balance |
            formatZero }}
        </div>
        <div class="itm">
          积分<Tip :titInd="2" style="width:20px;vertical-align: bottom"></Tip>：{{ loginInfo.vipInfo.points | formatZero
          }}
        </div>
        <div class="itm">
          幸运钥匙<Tip :titInd="5" style="width:20px;vertical-align: bottom"></Tip>：{{ loginInfo.wallteInfos[2].balance |
            formatZero }}
        </div>
        <div class="itm">
          好运符<Tip :titInd="3" style="width:20px;vertical-align: bottom"></Tip>
          ：{{ loginInfo.wallteInfos[3].balance | formatZero }}
        </div>
      </div>
      <div class="funBtn">
        <div class="recharge itm" @click="toRecharge">
          <img :src="require('@/assets/imgs/shop/loginRechange.png')" alt="" />
          <span>去充值</span>
        </div>
      </div>
      <div class="submitBar">
        <el-button @click="logout">安全退出</el-button>
        <!-- <el-button @click="transactionRecord">交易记录</el-button> -->
      </div>
    </template>
    <template v-else>
      <div class="loginTit mb10">账号登录</div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demoRuleForm">
        <el-form-item prop="username">
          <div class="item clearfix">
            <div class="pic fl"><img :src="usernameIcon" alt="" /></div>
            <div class="fr inp">
              <el-input v-model="ruleForm.username" trim placeholder="账号"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="item clearfix">
            <div class="pic fl"><img :src="passwordIcon" alt="" /></div>
            <div class="fr inp">
              <el-input v-model="ruleForm.password" type="password" placeholder="密码"></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="code">
          <div class="item clearfix item2">
            <div class="itemL fl">
              <div class="clearfix">
                <div class="pic fl"><img :src="codeIcon" alt="" /></div>
                <div class="fr inp">
                  <el-input v-model="ruleForm.code" placeholder="验证码"></el-input>
                </div>
              </div>
            </div>
            <div class="itemR fr">
              <img :src="codeImg" @click="getCaptcha" alt="" />
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="submitBar">
            <el-button @click="goRegister">立即注册</el-button>
            <el-button @click="submitForm('ruleForm')">安全登录</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="remberPassWord clearfix">
        <!--<div class="itm fl"><i :class="{isCheck:remberWord}"></i><span>记住账号</span></div>-->
        <div class="itm fr"><span>忘记密码</span></div>
      </div>
    </template>

  </div>
</template>

<script>
import Cookies from "js-cookie";
import eventBus from "@/common/bus.js";
import Tip from "@/components/Tip";
import { outLink } from "@/common/outLink.js";
import axios from "axios";

import {
  getCaptchaApi,
  getdoLoginApi,
  getMemberInfoApi,
  getlogoutApi
} from "@/api/login/index.js";

export default {
  name: "login",
  components: {
    Tip,
  },
  data() {
    return {

      isLoginStatus: false,
      loginInfo: {
        username: "",
        chargeMoney: 0,
        giftMoney: 0,
        points: 0,
        clothingCoupon: 0,
        wallteInfos: [],
      },
      token: "",
      userId: "",
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9]{4,16}$/,
            message: "用户名为4-16位字母或数字",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /^[^\u4e00-\u9fa5 ]{6,18}$/,
            message: "用户名为6-18位字母或数字",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "验证码长度为4个字符", trigger: "blur" },
        ],
      },
      usernameIcon: require("@/assets/imgs/shop/logoIcon1.png"),
      passwordIcon: require("@/assets/imgs/shop/logoIcon2.png"),
      codeIcon: require("@/assets/imgs/shop/logoIcon3.png"),
      codeImg: "",
    };
  },
  created() {
    if (Cookies.get("cwsl_token")) {
      let token = Cookies.get("cwsl_token");
      let userId = Cookies.get("cwsl_userId");
      this.token = token;
      this.userId = userId;
      this.getMemberInfo(token, userId);
    } else {
      this.getCaptcha(); // 获取图片验证码
    }

    /* 购买商品后用户信息重置 */
    eventBus.$on("resetUserInfo", this.getMemberInfo);
  },
  methods: {
    async getMemberInfo() {
      // 获取用户信息
      await getMemberInfoApi({
        platForm: "web",
        userId: Cookies.get("cwsl_userId"),
      })
        .then((res) => {
          if (res.data.state == 200) {
            this.isLoginStatus = true;
            this.loginInfo = res.data.data;
            this.resetSetItem("userInfo", JSON.stringify(res.data.data));
            // this.getUserInboxStatus()
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((e) => {
          Cookies.remove("cwsl_token");
        });
    },
    async getCaptcha() {
      // 获取图片验证码
      await getCaptchaApi({}).then((res) => {
        const setCookie = res.headers["Set-Cookie"];
        let imageType = res.headers["content-type"]; //获取图片类型
        const blob = new Blob([res.data], { type: imageType });
        const imageUrl = (window.URL || window.webkitURL).createObjectURL(blob);
        this.codeImg = imageUrl;
      });
    },

    submitForm(formName) {
      // 安全登录
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          await getdoLoginApi({
            username: this.ruleForm.username,
            password: this.ruleForm.password,
            code: this.ruleForm.code,
            type: 0,
            source: "shop",
          }).then((res) => {
            if (res.data.state == 200) {
              this.$message.success("登录成功");
              this.isLoginStatus = true;
              this.loginInfo = res.data.data;
              this.userId = res.data.data.userId;
              this.token = res.data.data.token;
              let seconds = 8 * 60 * 60; // 2*60*60;   2小时
              let expires = new Date(new Date() * 1 + seconds * 1000);

              // Cookies.set("cwsl_userId", res.data.data.userId, { expires: expires, }); // 本地登录
              // Cookies.set("cwsl_token", res.data.data.token, { expires: expires, });

              Cookies.set('cwsl_userId', res.data.data.userId, { domain: '.818long.com', expires: expires });   // 打包登录
              Cookies.set('cwsl_token', res.data.data.token, { domain: '.818long.com', expires: expires });

              this.getMemberInfo()
              eventBus.$emit("resetIndexGoodsList");
            } else {
              this.$message.error(res.data.message);
              this.getCaptcha(); // 刷新图片验证码
            }
          });
        } else {
          return false;
        }
      });
    },
    async logout() {
      // 退出登录

      await getlogoutApi({}).then((res) => {
        if (res.data.state == 200) {
          this.$message.success("退出成功");
          this.isLoginStatus = false;

          this.ruleForm.username = "";
          this.ruleForm.password = "";
          this.ruleForm.code = "";

          Cookies.remove("cwsl_userId", { domain: '.818long.com' });
          Cookies.remove("cwsl_token", { domain: '.818long.com' });

          Cookies.remove("cwsl_userId");
          Cookies.remove("cwsl_token");

          // Cookies.set("cwsl_userId", "",);
          // Cookies.set("cwsl_token", "",);
          localStorage.removeItem("userInfo");
          this.$router.push({ path: "/shop" });
          location.reload();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    transactionRecord() {
      this.$router.push({ path: "/shop?type=transactionRecord" });
    },
    toRecharge() {
      // 去充值
      window.open(outLink.officeRecharge);
    },
    goRegister() {
      // 立即注册
      window.open("http://mf.818long.com/#/register", "_blank");
    },
  },
  filters: {
    formatZero(val) {
      if (val == null) {
        return 0;
      } else {
        return val;
      }
    },
  },
};
</script>

<style lang="less">
.loginWrap {
  background: #fff;

  .el-input {
    height: 34px;
    line-height: 34px;

    input {
      padding: 0 10px;
      border: none;
      height: 34px;
      line-height: 34px;
      background: none;
    }
  }

  .submitBar {
    button {
      width: 112px;
      border-radius: 0;

      &:first-child {
        border: 1px solid #5472f6;

        span {
          color: #5472f6;
          font-size: 18px;
        }
      }

      &:last-child {
        border: 1px solid #5472f6;
        background: #5472f6;

        span {
          color: #fff;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
<style scoped lang="less">
.loginWrap {
  padding: 20px 18px;

  .loginTit {
    font-size: 20px;
    font-weight: 700;
  }

  .demoRuleForm {
    .item {
      height: 35px;
      border: 1px solid #999999;
      box-sizing: border-box;

      .pic {
        width: 34px;
        height: 34px;
        text-align: center;
        background: #5472f6;
      }

      .inp {
        width: 196px;
        height: 34px;
        line-height: 34px;
      }
    }

    .item2 {
      line-height: 34px;
      border: none;

      .itemL {
        width: 134px;
        border: 1px solid #999;

        .inp {
          width: 98px;
        }
      }

      .itemR {
        height: 34px;
        vertical-align: top;

        img {
          cursor: pointer;
        }

        button {
          padding: 0;
          width: 90px;
          height: 36px;
          line-height: 36px;
          border: none;
          border-radius: 0;
          background: #999;
          color: #fff;
        }
      }
    }
  }

  .submitBar {
    display: flex;
    justify-content: space-between;
  }

  .remberPassWord {
    line-height: 16px;

    .itm {
      width: 50%;
      text-align: center;

      &:first-child {
        span {
          vertical-align: top;
        }

        i {
          display: inline-block;
          margin-right: 5px;
          width: 14px;
          height: 14px;
          border: 1px solid #333;
          border-radius: 50%;
          cursor: pointer;
        }

        .isCheck {
          position: relative;
          z-index: 1;

          &::before {
            content: "";
            display: inline-block;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            width: 10px;
            height: 10px;
            background: #333;
            border: 2px solid #fff;
            border-radius: 50%;
          }
        }
      }

      &:last-child {
        text-decoration: underline;
      }
    }
  }

  .loginInfo {
    margin-bottom: 10px;

    .itm {
      margin-bottom: 15px;
      font-size: 18px;
      display: flex;
      align-items: center;

      img {
        margin-left: 3px;
        width: 24px;
      }
    }
  }

  .funBtn {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .itm {
      img {
        margin-right: 8px;
        vertical-align: middle;
      }

      span {
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .recharge {
      color: #b15fc6;
      cursor: pointer;
    }
  }
}
</style>
